// homiin brand assets (extracted from the supplied logo artwork). Files live in /public.
export const BRAND = {
  name: "HOMIIN Interiors",
  short: "HOMIIN",
  tagline: "Spaces that inspire life",
  LOGO_URL: "/logo-dark-on-light.png",   // horizontal lockup, mahogany — for light backgrounds
  LOGO_URL_DARK: "/logo.png",            // horizontal lockup, gold — for dark backgrounds
  LOGO_FULL_DARK: "/logo-full.png",      // stacked lockup with tagline, gold — footer
  MONOGRAM: "/monogram.png",
};
